import { Component } from '@angular/core';
import { Subscription } from 'rxjs';
import { CountryListService } from 'src/app/shared/dummy-data/country-list.service';
import { JobTitleService } from 'src/app/shared/dummy-data/job-create.service';
import { ApplyJobService } from 'src/app/shared/services/apply-job.service';
import { CandidateEmployerListService } from 'src/app/shared/services/candidate-employer-list.service';
import { AuthService } from 'src/app/store/auth/auth.service';

@Component({
  selector: 'app-assigned-candidates-list',
  templateUrl: './assigned-candidates-list.component.html',
  styleUrl: './assigned-candidates-list.component.scss'
})
export class AssignedCandidatesListComponent {
  userO = this.authService.userO;
  private userSub: Subscription;
  candidateList: any[] = [];
  loginUserData: any = {};
  candidateId: number;
  dataNotFound: string = "Candidate's Not Found";
  currentPage: number = 1;
  totalItemsPerPage = 10;
  totalPages: number = 0;
  totalItems: number = 0;
  name: string = "";
  candidateEmail: string = "";
  email: string = "";
  phoneNumber: string = "";
  category: string = "";
  jobStatus: any = [];
  specificCandidateId: any;
  SelectedStatus: any;
    city: any;
    country: any;
    city_list: any = {};
    country_list: any = {};

  constructor(
      private readonly candidateListService: CandidateEmployerListService,
      private readonly authService: AuthService,
      private jobTitleService: JobTitleService,
      private applyJobService: ApplyJobService,
      private readonly countryListService: CountryListService

  ) {}

  ngOnInit() {
      this.userSub = this.userO.subscribe((data) => {
          if (!data) return;
          if (data?.isData === true) {
              this.loginUserData = data?.body;
          }
      });
      this.getAllCandidatesAssignedToEmployer();
      this.getStatus();
      this.getCountryCitiesList();
      this.getCountryList()
  }

  getStatus() {
      this.jobStatus = this.jobTitleService.getStatus();
  }

  getAllCandidatesAssignedToEmployer() {
    this.candidateListService
        .getAllCandidatesAssignedToEmployer(
            this.currentPage,
            this.totalItemsPerPage,
            this.loginUserData?.email,  
            this.loginUserData?.email,
            this.name,  
            this.candidateEmail,
            this.country,
            this.city
        )
        .subscribe((res: any) => {
            this.candidateList = res?.body;
            this.totalItems = res?.totalRecords;
            this.totalPages = Math.ceil(
                this.totalItems / this.totalItemsPerPage
            );
        });
}

    //get Country List
    getCountryList(){
        this.country_list = this.countryListService.getJobCreateCountries()
    }
                
    //get Country List
    getCountryCitiesList(){
        this.city_list = this.countryListService.getJobCreateCities()
    }


  //status
  status(id: any) {
      this.specificCandidateId = id;
      //   console.log('iddddddddddddddddd',this.specificCandidateId)
  }

  onSelectedCountry(event: any) {
    const selectedCountry = event.value?.country;
    this.country = selectedCountry
    this.getAllCandidatesAssignedToEmployer()
    if(this.country){
        const allCities = this.countryListService.getJobCreateCities();
        this.city_list = allCities.filter(city => city.country === selectedCountry);
    }else{
        this.country = ""
        this.getAllCandidatesAssignedToEmployer()
    }
}



onSelectedCity(event:any){
   const selectedCity = event.value?.city;
   this.city = selectedCity
   this.getAllCandidatesAssignedToEmployer()
   const allCities = this.countryListService.getJobCreateCities();

   const match = allCities.find(city => city.city === selectedCity);
   if (match) {
     this.country = match.country;
     this.city_list = allCities.filter(city => city.country === match.country);
   }
}

  onChangeStatus(event: any) {
      console.log(event);
      this.SelectedStatus = event?.value?.status;
  }

  jobStatusPayload() {
      const payload = {
          status: this.SelectedStatus,
      };
      return payload;
  }


  //update job status
//   updateJobStatus() {
//       this.applyJobService
//           .updateJobStatus(this.specificCandidateId, this.jobStatusPayload())
//           .subscribe((res: any) => {
//               res;
//           });
//   }

  onPageChange(page: number) {
      if (page >= 1 && page <= this.totalPages) {
          this.currentPage = page;
          this.getAllCandidatesAssignedToEmployer()
          window.scrollTo(0, 0);
      }
  }

  //ngx-selector-dropDown-Configuration for job category
  statusConfig = {
      displayKey: "status",
      search: true,
      height: "auto",
      placeholder: "Job status",
      customComparator: () => {},
      moreText: "more",
      noResultsFound: "No results found!",
      searchPlaceholder: "Search",
      searchOnKey: "status",
      clearOnSelection: false,
      inputDirection: "ltr",
      multiple: true,
  };

     //ngx-selector-dropDown-Configuration
     CountryConfig = {
        displayKey: "country",
        search: true,
        height: "auto",
        placeholder: "Select Country",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "country",
        clearOnSelection: false,
        inputDirection: "ltr",
};


    //ngx-selector-dropDown-Configuration
   CitiesConfig = {
        displayKey: "city",
        search: true,
        height: "auto",
        placeholder: "Select City",
        customComparator: () => {},
        moreText: "more",
        noResultsFound: "No results found!",
        searchPlaceholder: "Search",
        searchOnKey: "city",
        clearOnSelection: false,
        inputDirection: "ltr",
};

  ngOnDestroy() {
      this.userSub.unsubscribe();
  }
}
